import React, { useState } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import Footer from "../components/Footer";
import Logo from "../components/Logo";

import SongSelectVideoTwo from "../pages/galeriaMusicalizada/SongSelectVideoTwo";
import TextsVideoTwo from "../pages/galeriaMusicalizada/TextsVideoTwo";
import RenderVideoTwo from "../pages/galeriaMusicalizada/RenderVideoTwo";

import FormPage from "../pages/FormPage";
import Home from "../pages/Home";
import Galery from "../components/Galery";

const Router = () => {
  const [isUpdateGalery, setIsUpdateGalery] = useState(false);

  const [songSelected, setSongSelected] = useState("");

  //video-two
  const [textOneVideoTwo, setTextOneVideoTwo] = useState("");

  const [textThreeVideoTwo, setTextThreeVideoTwo] = useState("");
  const [textFiveVideoTwo, setTextFiveVideoTwo] = useState("");

  const [imgOneVideoTwo, setImgOneVideoTwo] = useState();
  const [imgTwoVideoTwo, setImgTwoVideoTwo] = useState();
  const [imgThreeVideoTwo, setImgThreeVideoTwo] = useState();
  const [imgFourVideoTwo, setImgFourVideoTwo] = useState();
  const [imgFiveVideoTwo, setImgFiveVideoTwo] = useState();

  const [textColorOne, setTextColorOne] = useState("#efe9e5");
  const [textColorTwo, setTextColorTwo] = useState("#efe9e5");
  const [textColorThree, setTextColorThree] = useState("#efe9e5");

  const [anim_logo_home_trigger, setAnim_logo_home_trigger] = useState(false);

  const showMenu = () => {
    const body = document.querySelector("body");
    const menuMobil = document.querySelector(".menuMobil");
    body.classList.toggle("noScroll");
    menuMobil.classList.toggle("menuShow");
  };

  return (
    <HashRouter>
      <Logo anim={anim_logo_home_trigger} showMenu={showMenu} />
      <Routes>
        <Route path="/" element={<Home setAnim={setAnim_logo_home_trigger} />} />
        <Route path="/formulario" element={<FormPage />} />
        <Route
          path="/galeria"
          element={
            <Galery
              isUpdateGalery={isUpdateGalery}
              setIsUpdateGalery={setIsUpdateGalery}
            />
          }
        />

        {/* VIDEO DOSSSSSSSSSSSSSSSSS */}
        <Route
          path="/selecciona-audio-dos"
          element={<SongSelectVideoTwo setSongSelected={setSongSelected} />}
        />
        <Route
          path="/textos-video-dos"
          element={
            <TextsVideoTwo
              setTextColorOne={setTextColorOne}
              setTextColorTwo={setTextColorTwo}
              setTextColorThree={setTextColorThree}
              textOneVideoTwo={textOneVideoTwo}
              setTextOneVideoTwo={setTextOneVideoTwo}
              setImgOneVideoTwo={setImgOneVideoTwo}
              setTextThreeVideoTwo={setTextThreeVideoTwo}
              textThreeVideoTwo={textThreeVideoTwo}
              setTextFiveVideoTwo={setTextFiveVideoTwo}
              textFiveVideoTwo={textFiveVideoTwo}
              setImgTwoVideoTwo={setImgTwoVideoTwo}
              setImgThreeVideoTwo={setImgThreeVideoTwo}
              setImgFourVideoTwo={setImgFourVideoTwo}
              setImgFiveVideoTwo={setImgFiveVideoTwo}
              imgOneVideoTwo={imgOneVideoTwo}
              imgTwoVideoTwo={imgTwoVideoTwo}
              imgThreeVideoTwo={imgThreeVideoTwo}
              imgFourVideoTwo={imgFourVideoTwo}
              imgFiveVideoTwo={imgFiveVideoTwo}
            />
          }
        />

        <Route
          path="/render-video-dos"
          element={
            <RenderVideoTwo
              setIsUpdateGalery={setIsUpdateGalery}
              textColorOne={textColorOne}
              textColorTwo={textColorTwo}
              textColorThree={textColorThree}
              imgOneVideoTwo={imgOneVideoTwo}
              imgTwoVideoTwo={imgTwoVideoTwo}
              imgThreeVideoTwo={imgThreeVideoTwo}
              imgFourVideoTwo={imgFourVideoTwo}
              imgFiveVideoTwo={imgFiveVideoTwo}
              textOneVideoTwo={textOneVideoTwo}
              textThreeVideoTwo={textThreeVideoTwo}
              textFiveVideoTwo={textFiveVideoTwo}
              songSelected={songSelected}
            />
          }
        />
      </Routes>
      <Footer />
    </HashRouter>
  );
};

export default Router;
